import { apiClient } from "../config";

async function exportFormTemplate(id: any) {
  const res = await apiClient.get(`/admin/dynamic-forms/${id}/export-form-template`);
  return res.data;
}

export default exportFormTemplate;
